import stepTypes from 'components/Booking-new/modules/Steps/types';
import { getLocationStepData, orderLocations } from 'components/Booking-new/utils/steps/location';

class ContentfulProvider {
  constructor({ globalBooking, allDataService, allLocations, sortingAlgorithm, error }) {
    const {
      steps,
      stepReschedule,
      stepWaitlistData,
      id,
      freeParking,
      service,
      changeServiceLink,
      showNewsBanner,
      waitlistFlow,
      funnelType,
    } = globalBooking;

    this.steps = steps || [];
    this.reschedule = stepReschedule || {};
    this.waitlist = stepWaitlistData ? { ...stepWaitlistData, __typename: 'WaitlistData' } : {};
    this.id = id;
    this.config = {
      freeParking,
      service,
      changeServiceLink,
      errorPage: error || {},
      showNewsBanner: showNewsBanner,
      waitlistFlow,
      funnelType,
    };
    this.locations = orderLocations(steps, allLocations, sortingAlgorithm);
    this.services = allDataService;
  }

  getStep(type = null, data = {}, variant = 'a') {
    if (type === null) return {};

    return {
      type,
      variant,
      data: {
        ...data,
      },
    };
  }

  getRescheduleStep() {
    return this.getStep(stepTypes.reschedule, this.reschedule, 'a');
  }

  getWaitlistStep() {
    return this.getStep(stepTypes.waitlist, this.waitlist, 'a');
  }

  getAllSteps() {
    const whiteList = Object.values(stepTypes);
    return this.steps.reduce(
      (allSteps, currentStep) => {
        const stepType = currentStep.__typename;
        if (!whiteList.includes(stepType)) return allSteps;

        return [...allSteps, this.getStep(stepType, currentStep)];
      },
      [this.getRescheduleStep()],
    );
  }

  updateStepsByData(allSteps, stepsFunctions) {
    return allSteps.map(step => {
      const { type } = step;

      if (typeof stepsFunctions[type] !== 'undefined') {
        const updateFunction = stepsFunctions[type];
        return {
          ...step,
          data: {
            ...step.data,
            ...updateFunction(),
          },
        };
      }

      return step;
    });
  }

  getState(currentState, stepsFunction = {}) {
    const defaultStepsFunction = {
      [stepTypes.location]: () => getLocationStepData(this.locations),
      ...stepsFunction,
    };

    const allStepsWithData = this.updateStepsByData(this.getAllSteps(), defaultStepsFunction);

    return {
      ...currentState,
      bookingPrefix: this.id,
      allSteps: allStepsWithData,
      config: this.config,
      waitlistStep: this.getWaitlistStep(),
      locations: getLocationStepData(this.locations).locations,
      services: this.services,
    };
  }
}

export default ContentfulProvider;
